import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function FileloadingReducer(state = initialState.fileloading, action: any) {
  switch (action.type) {
    case types.SAVE_FILELOADING_SUCCESS:
      return action.fileloading;
    default:
      return state;
  }
}
